import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import "./Questions32.css"
import Dashboard from '../Dashboard/Dashboard'
import bul from "../../images/bul.png"
import "../NavbarNew/NavbarNew.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import deep from "../../images/asm-banner.jpg"
import loadimg from "../../images/loader_wish.gif";
import dw from "../../images/file.png";
import buttonloader from "../../images/buttonloader.gif";
import { END_URL, IMG_URL } from "../../config";
import Subscriptions from '../Subscriptions/Subscriptions';
import { set } from 'react-hook-form';

// import arr from "../../images/arrow-s.svg";

function Questions32({ onLoginChange,globaltest,userdetail }) {

  const [ButtonLoad, setButtonLoad] = useState(false);

  const [deepDiveData, setDeepDiveData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const [UserSub, setUserSub] = useState(false);

  const [BannerContent, setBannerContent] = useState({});

  // const [Subscription, setSubscription] = useState({});

  const [FreeTestAttend, setFreeTestAttend] = useState(false);

  const [FreeTestSub,setFreeTestSub] = useState(false);

  const [showPopup, setshowPopup] = useState(false);

  const [showFreeSub,setshowFreeSub] = useState(false);

  const [FreeTest, setFreeTest] = useState({});

  const [pdfUrl, setPdfUrl] = useState(null);

    
  const containerRef = useRef(null);

  const [hasImage, setHasImage] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [SubscriptionHandle, setSubscriptionHandle] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [loadingBanner, setLoadingBanner] = useState(true);


  const [BannerImage, setBannerImage] = useState(null);

  const [PastResult,setPastResult] = useState(null);

  const [HaveResult,setHaveResult] = useState(null);

  
  // useEffect(() => {

  //   if (!isLoading) {
      
  //     const showTimer = setTimeout(() => {
  //       setLoadingBanner(false);
  //     }, 3000);

  //     return () => clearTimeout(showTimer);
  //   } 

  // }, [isLoading]);

     useEffect(() => {
        
          window.scrollTo({ top: 0, behavior: 'smooth' });

    }, []);

  
  useEffect(() => {
    const container = containerRef.current;
    if (container && container.querySelector('img')) {
      setHasImage(true);
    }
  }, [BannerContent?.advertisment_32]);


  useEffect(() => {

    if (!token) {

      window.scrollTo({ top: 0, behavior: 'smooth' });
      onLoginChange(true);
    }

  }, [token]);

    useEffect(() => {

     const fetchBanner = async () => {

        setLoadingBanner(true);
        try {
          const [res] = await Promise.all([
            axios.get(`${END_URL}/deep_banner`),
          ]);

          const BannerData = res.data.image1;

          setBannerImage(BannerData);

          setError(null);

        } catch (err) {
        
        } finally {

          setLoadingBanner(false);

        }
      };

      fetchBanner();
  }, []);


  useEffect(() => {

    setIsLoading(true);

    const fetchData = async () => {
      
        const response = await axios.get(`${END_URL}/deepdivedesc`,
          {
              headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json'
              },
          }
        );

        setDeepDiveData(response.data.data[0]);

        setBannerContent(response.data.banner_content);

        setSubscriptionHandle(response.data.sub);

        setUserSub(response.data.user_sub?.deep_sub);

        setFreeTestAttend(response.data.user_attent_free_test);

        setFreeTestSub(response?.data?.user_have_free_test_sub);

        setFreeTest(response.data.test);

        setPastResult(response.data.isPastResult);

        setHaveResult(response.data.is_latest_have_result);

        // fetchPdfUrl();

        setIsLoading(false);

  
    };

    fetchData();
  }, [token]);

   const handleSub = async (subJson) => {

        try {

        let subIds = [];
    
            if (typeof subJson === "string") {
            try {
                subIds = JSON.parse(subJson);
            } catch (e) {
                console.error("Invalid JSON string for subIds:", e);
                return;
            }
            } else if (Array.isArray(subJson)) {
            
            subIds = subJson;
            }

            setshowFreeSub(false);
            
            setShowModal(true);

            const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            );

            setSubscription(res.data);

        } catch (err) {
            
            console.error("Error loading subscriptions:", err);
        }
    };


  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

      const AttentTest = () =>
      {
        setshowPopup(true);
      }

      const TakeFreeSub = () =>
      {
          setshowFreeSub(true);
      }


      const HandlePayment = (item) => {
  
          const InitializePayment = async () => {
  
              try {

                  setButtonLoad(true);
  
                  const response = await fetch(`${END_URL}/test-payment`, {
  
                      method: "POST",
                      headers: {
  
                          Authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                      },
  
                      body: JSON.stringify(item)
  
                  });
  
                  const data = await response.json();
  
                  console.log(data.payment, 'fetch data');
  
                  if (data.payment) {
  
                    setButtonLoad(false);
                      window.location.href = data.payment;
  
                  } else {

                      setButtonLoad(false);

                      console.error("Invalid response:", data);
                      alert("An error occurred while processing the request.");
                  }
  
              } catch (error) {
  
                  console.error("Error sending result:", error);
              }
          };
  
          InitializePayment();
  
      };

 return (
  
      <div className="ques-main">

            <div className="container-fluid">
              <div className="row ques-row">
                <div className="col-12">
                  <div className={`ques-top ${loadingBanner ? 'load-banner' : ''}`}
                      style={{
                        background: `url(${BannerImage}) no-repeat center center`,
                        backgroundSize: 'cover',
                      }}
                  >

                    <div className="ques-top-title" dangerouslySetInnerHTML={{ __html:BannerContent?.banner_content_32 }} />
                
                  </div>
                </div>
              </div>
            </div>

         {isLoading ? (
            
            <div className="loader-container col-12 text-center py-5">
              <img src={loadimg} alt="Loading..." className="loader-gif" />
            </div>
          ) : (

            <div className="container-fluid question-fluid">
              <div className="row ques-sec-row">
                <div className="col-12 col-sm-12 col-md-3 ques-side">
                  <Dashboard globaltest={globaltest} />
                </div>

                {token && (
                  <>
                    <div className="col-12 col-sm-12 col-md-6 ques-right">

                      <div className="row deep-pop">
                          <div className="col-md-12">
                            {!HaveResult && (
                              <div
                                className="alert alert-info"
                                dangerouslySetInnerHTML={{
                                  __html: BannerContent?.deep_drive_submit_message,
                                }}
                                style={{ marginBottom: "20px" }}
                              />
                            )}
                          </div>
                      </div>

                      <div className="ques-middle">

                        <div
                          dangerouslySetInnerHTML={createMarkup(deepDiveData?.description1)}
                        />

                        <table className="styled-table">
                          <tbody>
                            <tr>
                              <td className="field">Time:</td>
                              <td className="content">{deepDiveData?.time}</td>
                            </tr>
                            <tr>
                              <td className="field">Return:</td>
                              <td className="content">{deepDiveData?.return}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div
                          dangerouslySetInnerHTML={createMarkup(deepDiveData?.description2)}
                        />

                        <div className="ques-btn">

                        {PastResult &&  (
                            <a className="nav-head-out-btn combine-btn">

                          
                                  <button
                                      className="nav-head-out-btn-text"

                                      onClick={() => navigate("/past-attempts")}
                                    >
                                        {BannerContent?.pesonality_32_Past_label}

                                        <span>
                                          
                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                          
                                      </span>
                          
                                  </button>
                            </a>

                          )}

                        {HaveResult && (

                            <a className="nav-head-out-btn combine-btn"> 
                              
                              {UserSub ? (

                                      FreeTestSub || userdetail?.user_all_access == 1 ? (
                                  
                                            (FreeTestAttend && FreeTestSub) ? (

                                                  HaveResult && (
                                                    
                                                      <button
                                                          className="nav-head-out-btn-text"
                                                          onClick={() =>navigate("/deep") }
                                                              
                                                        >
                                                            {BannerContent?.pesonality_32_label}

                                                            <span>
                                                              {!ButtonLoad &&
                                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                              }

                                                              {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                                          </span>
                                              
                                                      </button>
                                                  )
                                            ):
                                            (
                                            
                                                  <button
                                                      className="nav-head-out-btn-text"
                                                      onClick={() =>AttentTest() }
                                                          
                                                    >
                                                        {BannerContent?.pesonality_32_label}
                                                        <span>
                                                          {!ButtonLoad &&
                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                          }

                                                          {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                                      </span>
                                          
                                                  </button>
                                            )
                                    ):
                                    (
                                  
                                          <button
                                              className="nav-head-out-btn-text"
                                              onClick={() =>TakeFreeSub() }
                                                  
                                            >
                                                {BannerContent?.pesonality_32_label}

                                                <span>
                                                  {!ButtonLoad &&
                                                    <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                  }

                                                  {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                              </span>
                                  
                                          </button>
                                    )
                              ):
                              (
                                
                                  FreeTestSub ? (
                                  
                                            FreeTestAttend ? (

                                                HaveResult && (

                                                    <button
                                                          className="nav-head-out-btn-text"

                                                          // onClick={() => HandlePayment(SubscriptionHandle) }

                                                          onClick={ () => handleSub([SubscriptionHandle?.id])}
                                                        >
                                                            {BannerContent?.pesonality_32_label}

                                                            <span>
                                                              {!ButtonLoad &&
                                                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                              }

                                                              {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                                          </span>
                                              
                                                      </button>
                                                )

                                            ):
                                            (
                                            
                                                  <button
                                                      className="nav-head-out-btn-text"
                                                      onClick={() =>AttentTest() }
                                                          
                                                    >
                                                        {BannerContent?.pesonality_32_label}

                                                        <span>
                                                          {!ButtonLoad &&
                                                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                          }

                                                          {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                                      </span>
                                          
                                                  </button>
                                            )
                                    ):
                                    (
                                  
                                          <button
                                              className="nav-head-out-btn-text"
                                              onClick={() =>TakeFreeSub() }
                                                  
                                            >
                                              {BannerContent?.pesonality_32_label}

                                                <span>
                                                  {!ButtonLoad &&
                                                    <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                                  }

                                                  {ButtonLoad && <img src={buttonloader} alt="Loading" style={{marginLeft: '0px', width: '33px', height: '33px' }} /> }
                                              </span>
                                  
                                          </button>
                                    )

                              )}

                          </a> )}


                        </div>
                      </div>


                      {BannerContent?.advertisment_32 && (

                        <div className="col-12 col-sm-12 col-md-3 ques-end ques-center">
                            <div className="ques-end-div">

                            {!hasImage && (

                              <div className="ques-ed1">

                                <img src={bul} alt="" />

                              </div>

                            )}

                              <div  ref={containerRef} className={`ques-ed2 ${hasImage ? ' has-image' : ''}`} dangerouslySetInnerHTML={{ __html:BannerContent?.advertisment_32 }}/>
                               
                            </div>
                        </div>
                      )}

                    </div>


                   {showPopup && (
                                               
                        <div className="newdashpop-overlay subs-cognit-modal1 ques32">
                            <div className="newdashpop-inner">
                            <div className="newdashpop-container">
                                <button
                                className="newdashpop-close"
                                onClick={() => setshowPopup(false)}
                                >
                                &times;
                                </button>
        
                                <div className="conent-pop" dangerouslySetInnerHTML={{ __html: FreeTest?.not_attend_free_test}} />
        
                                <a
                                    className="home-slider-sun-box-a"
                                    href={`test/${FreeTest?.slug}`}
                                    rel="noopener noreferrer"
                                >
                                <span className="home-slider-sun-box-a-text">{FreeTest?.not_attend_free_test_label}</span>
                                <span className="home-slider-sun-box-a-icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                    )}

                    {showFreeSub && (
                                  
                        <div className="newdashpop-overlay subs-cognit-modal1 ques32-pp">
                            <div className="newdashpop-inner">
                                <div className="newdashpop-container  sub-no">
                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setshowFreeSub(false)}
                                        >
                                    &times;
                                    </button>
            
                                    <div className="conent-pop subs-left">
                                        
                                        <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: FreeTest?.not_have_free_test}} />

                                        <button
                                        
                                          // onClick={() => HandlePayment(FreeTest?.sub)}

                                           onClick={ () => handleSub(FreeTest?.not_have_free_test_sub_link)}
                                         >
                                        
                                            {FreeTest?.not_have_free_test_label}

                                            <span>

                                                {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}
                                                
                                            </span> {ButtonLoad && <img  src={buttonloader} alt="Loading" />}
                                    
                                        </button>

                                    </div>
            
                                
                                </div>
                            </div>
                        </div>
                    )}


                    {BannerContent?.advertisment_32 && (

                        <div className="col-12 col-sm-12 col-md-3 ques-end">
                          <div className="ques-end-div">

                             {!hasImage && (

                              <div className="ques-ed1">

                                <img src={bul} alt="" />

                              </div>
                            )}

                              <div  ref={containerRef} className={`ques-ed2 ${hasImage ? ' has-image' : ''}`} dangerouslySetInnerHTML={{ __html:BannerContent?.advertisment_32 }}/>

                          </div>
                        </div>
                      )}

                  </>
                )}
              </div>
            </div>
          )}


          {ShowModal && (
                                  
            <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                    subscription?.data?.length === 1 ? "single-subscription" : ""
                  }`}
                
                >

                    <div className="newdashpop-inner">

                        <div className="newdashpop-container">

                            <button
                                className="newdashpop-close"
                                onClick={() => setShowModal(false)}
                                >
                                &times;
                            </button>

                            <div className="conent-pop">
                            
                            <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                            </div>

                        </div>

                    </div>

                </div>
            )}

            
          </div>
      );

}

export default Questions32;
